import styled from 'styled-components';

export const BubbleDetail = () => (
  <StyledSvg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="17"
    viewBox="0 0 9 17"
    fill="currentColor"
  >
    <path
      d="M0.772965 3.01404C-0.0113096 1.68077 0.950002 0 2.49683 0H9V17L0.772965 3.01404Z"
      fill="currentColor"
    />
  </StyledSvg>
);

const StyledSvg = styled.svg`
  position: absolute;
  top: 0;
  left: -9px;

  html[dir='rtl'] & {
    right: -9px;
    left: unset;
    transform: scale(-1, 1);
  }
`;
